import Icon from 'Components/Icon';
import { useTranslation } from 'react-i18next';

const InsuranceFieldListItem = (props: any) => {
    const [t] = useTranslation()

    return (
        <div className="flex gap-2 px-6 py-3">
            <div className="avatar avatar-circular avatar-secondary avatar-48">
                <Icon name="security" />
            </div>
            <div className="flex flex-col gap-2 grow overflow-hidden">
                <div className='flex justify-between items-center'>
                    <div className="font-semibold text-sm truncate text-gray-800">
                        {props.insuranceTypeTitle}
                    </div>
                    <div className="font-semibold text-sm truncate text-gray-800">
                        {props.operationTypeName}
                    </div>
                </div>
                <div className="flex justify-between items-center">
                    <div className="text-xs text-gray-500 shrink-0">{t("COVERAGE_LIMIT")}:</div>
                    <div className="text-xs text-gray-800 font-bold">{props.coverageLimit == null ? t("UN_LIMITED") : Number(props.coverageLimit).toLocaleString() + " " + t("PRICE_UNIT")}</div>
                </div>
            </div>
        </div>
    );
}

export default InsuranceFieldListItem;